import dayjs from "dayjs";
import * as Yup from "yup";

const validationAadhaarSchema = Yup.object({
  name: Yup.string()
    .matches(
      /^[A-Za-z .]+$/,
      "Please enter a valid name using alphabetic characters, spaces, and periods only."
    )
    .required("Enter full name")
    .min(2, "First name minimum 2 characters")
    .max(100, "First and last name combined should not exceed 40 characters"),
  dateOfBirth: Yup.date()
    .required("Enter valid date of birth")
    .typeError("Invalid date. Please use a valid date.")
    .test("age-range", "Age must be between 18 and 65 years.", (date) => {
      const today = dayjs();
      const birthDate = dayjs(date);
      const age = today.diff(birthDate, "year");
      return age >= 18 && age <= 65;
    }),
  gender: Yup.string().required("Choose gender"),
  mobileNo: Yup.string()
    .matches(
      /^[0-9]{10}$/,
      "Invalid mobile number. Please enter a 10-digit number"
    )
    .required("Enter Valid Mobile Number"),
  email: Yup.string()
    .email("Invalid email ID")
    .required("Enter valid email address"),
  // aadhaar: Yup.string()
  //   .matches(
  //     /^[0-9]{12}$/,
  //     "Invalid Aadhaar number. Please enter a 12-digit number"
  //   )
  //   .required("Enter valid identity number"),
  address: Yup.string()
    .max(200, "Please enter a valid street address in 200 characters")
    .required("Enter full address"),
  pinCode: Yup.string()
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode")
    .required("Enter valid pincode"),
});

const validationPanSchema = Yup.object({
  name: Yup.string()
    .matches(
      /^[A-Za-z .]+$/,
      "Please enter a valid name using alphabetic characters, spaces, and periods only."
    )
    .required("Enter full name")
    .min(2, "First name minimum 2 characters")
    .max(100, "First and last name combined should not exceed 100 characters"),
  dateOfBirth: Yup.date()
    .required("Enter valid date of birth")
    .typeError("Invalid date. Please use a valid date.")
    .test("age-range", "Age must be between 18 and 65 years.", (date) => {
      const today = dayjs();
      const birthDate = dayjs(date);
      const age = today.diff(birthDate, "year");
      return age >= 18 && age <= 65;
    }),
  gender: Yup.string().required("Choose gender"),
  mobileNo: Yup.string()
    .matches(
      /^[0-9]{10}$/,
      "Invalid mobile number. Please enter a 10-digit number"
    )
    .required("Enter Valid Mobile Number"),
  email: Yup.string()
    .email("Invalid email ID")
    .required("Enter valid email address"),
  // pan: Yup.string()
  //   .matches(
  //     /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
  //     "Invalid PAN number. Please enter a valid 10-character PAN number"
  //   )
  //   .required("Enter valid identity number"),
  address: Yup.string()
    .max(200, "Please enter a valid street address in 200 characters")
    .required("Enter full address"),
  pinCode: Yup.string()
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode")
    .required("Enter valid pincode"),
});

const validationUpdateSchema = Yup.object({
  name: Yup.string()
    .matches(
      /^[A-Za-z .]+$/,
      "Please enter a valid name using alphabetic characters, spaces, and periods only."
    )
    .required("Enter full name")
    .min(2, "First name minimum 2 characters")
    .max(100, "First and last name combined should not exceed 100 characters"),
  dateOfBirth: Yup.date()
    .required("Enter valid date of birth")
    .typeError("Invalid date. Please use a valid date.")
    .test("age-range", "Age must be between 18 and 65 years.", (date) => {
      const today = dayjs();
      const birthDate = dayjs(date);
      const age = today.diff(birthDate, "year");
      return age >= 18 && age <= 65;
    }),
  gender: Yup.string().required("Choose gender"),
  mobileNo: Yup.string()
    .matches(
      /^[0-9]{10}$/,
      "Invalid mobile number. Please enter a 10-digit number"
    )
    .required("Enter Valid Mobile Number"),
  email: Yup.string()
    .email("Invalid email ID")
    .required("Enter valid email address"),
  pinCode: Yup.string()
    .matches(/^[0-9]{6}$/, "Please enter a valid 6-digit pincode")
    .required("Enter valid pincode"),
});

export { validationAadhaarSchema, validationPanSchema, validationUpdateSchema };
